"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EHoliday;
(function (EHoliday) {
    EHoliday["Pesach"] = "Pesach";
    EHoliday["Shavuot"] = "Shavuot";
    EHoliday["Rosh_Hashana"] = "Rosh Hashana";
    EHoliday["Yom_Kippur"] = "Yom Kippur";
    EHoliday["Sukkot"] = "Sukkot";
    EHoliday["Simchat_Torah"] = "Simchat Torah";
    EHoliday["Shmini_Atzeret"] = "Shmini Atzeret";
    EHoliday["Hoshana_Raba"] = "Hoshana Raba";
})(EHoliday = exports.EHoliday || (exports.EHoliday = {}));
var EScheduleStatuses;
(function (EScheduleStatuses) {
    EScheduleStatuses["LIMITED_HOURS"] = "LIMITED_HOURS";
    EScheduleStatuses["CLOSED"] = "CLOSED";
    EScheduleStatuses["OPEN"] = "OPEN";
})(EScheduleStatuses = exports.EScheduleStatuses || (exports.EScheduleStatuses = {}));
;
exports.ScheduleStatusesMap = {
    [EScheduleStatuses.LIMITED_HOURS]: 'Limited Hours',
    [EScheduleStatuses.CLOSED]: 'Closed',
    [EScheduleStatuses.OPEN]: 'Open'
};
